













































import { Vue, Component, Prop } from 'vue-property-decorator';
import Avatar from '@components/v2/Avatar.vue';
import { State } from 'vuex-class';
import ImagePrivate from '@/components/common/ImagePrivate.vue';
import { getNewUserStateName, NEW_USER_STATE, USER_TREATMENT_STATE } from '@/common/constants/auth';
import lodashGet from 'lodash/get';
import { MESSAGE_TYPE } from '@/common/enums/message';
import lodashIncludes from 'lodash/includes';
import { Roles } from '@/common/app.config';

@Component({
  components: {
    ImagePrivate,
    Avatar,
  },
})
export default class PatientItem extends Vue {
  @State((state) => state.auth.currentUser) currentUser!: any;
  @Prop({ required: true }) patient!: any;
  @Prop({ required: true }) showCheckbox!: boolean;
  private unreadCountValue: any = 0;
  private localLatestMessage: any = null;
  private isMatchedChannel: boolean = false;

  handleCheckboxClick(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    event.stopPropagation();
    this.$emit('checkbox', isChecked, this.patient );
  }

  isCheckbox() {
    return this.showCheckbox && this.patient.doctor_chat_state === NEW_USER_STATE.DOCTOR_CHAT_UNREPLY;
  }

  get lastMessage() {
    const lstMessage = this.localLatestMessage;

    if (
      lstMessage &&
      lodashIncludes(
        [MESSAGE_TYPE.BUTTON, MESSAGE_TYPE.DOCTOR_FEEDBACK_PENDING],
        lstMessage.type,
      )
    ) {
      return '';
    }

    return lstMessage?.message || lstMessage?.message_content || '';
  }

  mounted() {
    this.unreadCountValue = lodashGet(this.patient, 'channels.unread_count', 0);
    this.localLatestMessage = lodashGet(this.patient, 'channels.latest_message', null);
    (this.$root as any).$on('TotalUnreadCount', this.handleTotalUnreadCount);
    (this.$root as any).$on('UpdateLatestMessage', this.onUpdateLatestMessage);
  }

  beforeDestroy() {
    (this.$root as any).$off('TotalUnreadCount', this.handleTotalUnreadCount);
    (this.$root as any).$off('UpdateLatestMessage', this.onUpdateLatestMessage);
  }

  private onUpdateLatestMessage(data: any) {
    const channelId = lodashGet(this.patient, 'channels.id');

    if (String(channelId) !== String(data?.channel_id)) {
      return this.isMatchedChannel = false;
    }
    this.isMatchedChannel = true;
    const HIDDEN_TYPES = [
      MESSAGE_TYPE.BUTTON,
      MESSAGE_TYPE.DOCTOR_FEEDBACK_PENDING,
    ];

    if (HIDDEN_TYPES.includes(data?.type_message)) {
      this.localLatestMessage = null;
    } else {
      this.localLatestMessage = data;
    }
  }

  private handleTotalUnreadCount(event: any) {
    if (!this.isMatchedChannel) {
      return;
    }
    this.unreadCountValue = event.unreadMessageCount || 0;
  }

  get getUnreadCount() {
    const unreadCount = this.unreadCountValue;

    if (unreadCount > 99) {
       return '99+';
    }

    return unreadCount;
  }

  get isShowUserTreatmentIcon() {
    const userTreatmentsArray = lodashGet(this.patient, 'userTreatments', []);

    const allowableState = [
      USER_TREATMENT_STATE.CHOICE_INTERVIEW_METHOD,
      USER_TREATMENT_STATE.CHAT_INTERVIEW_SCHEDULED,
      USER_TREATMENT_STATE.VIDEO_INTERVIEW_DATE,
      USER_TREATMENT_STATE.DOCTOR_PRESCRIPTION_CHECK,
      USER_TREATMENT_STATE.CHAT_CONSULTATION_IN_PROGRESS,
    ];

    const foundUserTreatment = userTreatmentsArray.find((userTreatment) => {
      const userTreatmentState = lodashGet(userTreatment, 'state', null);
      return userTreatmentState
        && allowableState.includes(userTreatmentState)
        && this.currentUser?.isDoctorRole
        && userTreatment?.feedback_type !== NEW_USER_STATE.DOCTOR_RESERVE_PRESCRIPTION;
    });
    return !!foundUserTreatment;
  }

  get patientName() {
      return `${this.patient.family_name || ''} ${this.patient.given_name || ''}`.trim() || '-';
  }

  get getStatusName() {
    return getNewUserStateName(this.patient.new_state);
  }

  get handlerText() {
    const type = this.patient?.handler_type;
    if (!type) {
      return '';
    }

    const isDoctor = this.currentUser.role === Roles.doctor;

    if (type === 'all') {
      return isDoctor ? 'ドクター対応中' : 'CS対応中';
    }

    const TEXT_MAP = {
      cs: 'CS対応中',
      doctor: 'ドクター対応中',
    };

    return TEXT_MAP[type] || (isDoctor ? 'ドクター対応中' : 'CS対応中');
  }
}
